import { haveFilterQuery, paginator, haveSort } from '../common/auxFun'

const endpointsRoles = {
  CREATE: '/v1/settings/roles',
  BY_ROLE: (id) => `/v1/settings/roles/${id}`,
  LOAD: (filter, sort, limit, skip) =>
    `/v1/settings/roles${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
}

export default endpointsRoles
